<template>
  <!-- Page Content -->
  <div class="whole-page" id="whole-page-opt-div">
    <AIChatFloat :colorTheme="colorTheme" />
    <div class="navbar-div">
      <NavbarComponent
        :colorTheme="colorTheme"
        :selectedNavLink="selectedNavLink"
        :user="user"
        analysis="OPTIMIZER"
        @eventOnUserSelectNavLink="eventOnClientSelectAsset"
        @eventOnUserColorTheme="onUserColorTheme"
      />
    </div>
    <Currency
      v-if="selectedNavLink === 0"
      :colorTheme="colorTheme"
      :companies="companies"
      :countrySpecs="countrySpecs"
      :currencyPKs="currencyPKs"
      :currencySpecs="currencySpecs"
      :processData="processData"
    />
    <Commodity
      v-if="selectedNavLink === 1"
      :colorTheme="colorTheme"
      :commoditySpecs="commoditySpecs"
      :companies="companies"
      :countrySpecs="countrySpecs"
      :processData="processData"
    />
  </div>
</template>

<script>
import AIChatFloat from "@/components/ai/AIChatFloat.vue";
import Commodity from "@/components/optimizer/Commodity";
import Currency from "@/components/optimizer/Currency";
import NavbarComponent from "@/components/Navbar.vue";
import {
  assetSelectionVuex,
  colorThemeChange,
  colorThemeVuex,
  sortByKey,
} from "@/_core/_helpers/_helpers";
import { filterCurrenciesWithValuationData } from "@/_core/data/Optimizer";
import { ProcessData } from "@/_core/data/ProcessData";
import { saveUserPreferences } from "@/_core/data/SaveToDB";

export default {
  name: "optimizer",
  components: {
    AIChatFloat,
    Commodity,
    Currency,
    NavbarComponent,
  },
  data() {
    return {
      optimizer_preferences: {},
      colorTheme: true, // true = dark, else light
      commoditySpecs: [],
      companies: [],
      countrySpecs: [],
      currencyPKs: [],
      currencySpecs: [],
      processData: null,
      root: document.documentElement,
      selectedAssetLink: 0,
      user: [],
      selectedNavLink: 0,
    };
  },
  created() {
    this.optimizer_preferences = this.$store.state.user_preferences.all.items.optimizer_choices;
    try {
      this.colorTheme = this.optimizer_preferences.color_theme;
      if (this.colorTheme === undefined) {
        this.colorTheme = true;
      }
      if (!this.colorTheme) {
        colorThemeChange(this.root, this.colorTheme);
        this.onUserColorTheme(this.colorTheme);
      }
    } catch (error) {
      console.log(`Error color theme ${error}`);
    }
    try {
      this.processData = new ProcessData();
    } catch (error) {
      console.log(`Error Process Data ${error}`);
    }
    try {
      this.selectedNavLink = this.optimizer_preferences.selected_nav;
    } catch (error) {
      this.selectedNavLink = 0;
      console.log(`Error selected custom nav asset ${error}`);
    }
    try {
      this.user = this.$store.state.user.all.items;
    } catch (error) {
      console.log(`Error user ${error}`);
    }
    try {
      this.companies = this.$store.state.companies.all.items;
      this.companies = sortByKey(this.companies, "company_name");
      this.companies.forEach(function(d, i) {
        d.id = i;
      });
    } catch (error) {
      console.log(`Error companies ${error}`);
    }
    try {
      this.currencySpecs = this.$store.state.currencies.all.items;
      this.currencySpecs = filterCurrenciesWithValuationData(
        this.currencySpecs,
      );
      this.currencyPKs = this.currencySpecs.map((d) => d.pk_i_idcurrency);
    } catch (error) {
      console.log(`Error currencies ${error}`);
    }
    try {
      this.countrySpecs = this.$store.state.countries.all.items;
    } catch (error) {
      console.log(`Error countries ${error}`);
    }
    try {
      this.commoditySpecs = this.$store.state.commodities.all.items;
    } catch (error) {
      console.log(`Error commodities ${error}`);
    }
    // document.title = "Optimizer | Quanspire";
  },
  methods: {
    onUserColorTheme(val) {
      this.colorTheme = val;
      this.optimizer_preferences.color_theme = val;
      colorThemeVuex(this, this.colorTheme);
      saveUserPreferences(this);
    },
    eventOnClientSelectAsset(idx) {
      this.selectedNavLink = idx;
      this.optimizer_preferences.selected_nav = idx;
      assetSelectionVuex(this, this.selectedNavLink);
      this.$store.state.user_preferences.all.items.optimizer_choices = this.optimizer_preferences;
      saveUserPreferences(this);
    },
  },
};
</script>
